export const PRODUCTION_INSTANCE_TYPE = "Production";
export const TEST_INSTANCE_TYPE = "Test";
export const DEV_INSTANCE_TYPE = "Development";